import api from '@api';
import { withArchiveMode } from 'src/utils/archiveMode';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getClaimDetailFetchSuccess,
    getClaimDetailFetchFailure,
    getClaimDetailChangelogFetchSuccess,
    getClaimDetailChangelogFetchFailure,
    createClaimDetailFetchSuccess,
    createClaimDetailFetchFailure,
    updateClaimDetailFetchSuccess,
    updateClaimDetailFetchFailure,
    patchClaimDetailFetchSuccess,
    patchClaimDetailFetchFailure,
    editClaimDetailEshopNoteFetchSuccess,
    editClaimDetailEshopNoteFetchFailure,
} from './reducer';
import { ClaimDetailResType } from 'src/types/claimDetail';
import { ClaimType } from 'src/types/claim';
import translate from '@translate';

const getClaimDetailFetchRequest = async (idClaim: string) => {
    const res = await api('get', withArchiveMode(`api/secure/claims/${idClaim}`));
    return res.data;
};

function* getClaimDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ClaimDetailResType = yield call((): any => getClaimDetailFetchRequest(action.payload));
        yield put(getClaimDetailFetchSuccess(response));
    } catch (error) {
        yield put(getClaimDetailFetchFailure({ error }));
    }
}

export function* getClaimDetailFetchWatch() {
    yield takeEvery('claimDetail/getClaimDetailFetch', getClaimDetailFetch);
}

const createClaimDetailFetchRequest = async (data: ClaimType) => {
    const res = await api('post', 'api/secure/claims', data);
    return res.data;
};

function* createClaimDetailFetch(action: { type: string; payload: ClaimType }) {
    try {
        const response: ClaimDetailResType = yield call((): any => createClaimDetailFetchRequest(action.payload));
        yield put(
            createClaimDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('claims.message.claimCreated') },
            })
        );
    } catch (error) {
        yield put(createClaimDetailFetchFailure({ error }));
    }
}

export function* createClaimDetailFetchWatch() {
    yield takeEvery('claimDetail/createClaimDetailFetch', createClaimDetailFetch);
}

const updateClaimDetailFetchRequest = async (params: { idClaim: string; data: ClaimType }) => {
    const res = await api('put', `api/secure/claims/${params.idClaim}`, params.data);
    return res.data;
};

function* updateClaimDetailFetch(action: { type: string; payload: { idClaim: string; data: ClaimType } }) {
    try {
        const response: ClaimDetailResType = yield call((): any => updateClaimDetailFetchRequest(action.payload));
        yield put(
            updateClaimDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('claims.message.claimUpdate') },
            })
        );
    } catch (error) {
        yield put(updateClaimDetailFetchFailure({ error }));
    }
}

export function* updateClaimDetailFetchWatch() {
    yield takeEvery('claimDetail/updateClaimDetailFetch', updateClaimDetailFetch);
}

const patchClaimDetailFetchRequest = async (params: { idClaim: string; data: Partial<ClaimType> }) => {
    const res = await api('patch', `api/secure/claims/${params.idClaim}`, params.data);
    return res.data;
};

function* patchClaimDetailFetch(action: { type: string; payload: { idClaim: string; data: Partial<ClaimType> } }) {
    try {
        const response: ClaimDetailResType = yield call((): any => patchClaimDetailFetchRequest(action.payload));
        yield put(
            patchClaimDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('claims.message.claimUpdate') },
            })
        );
    } catch (error) {
        yield put(patchClaimDetailFetchFailure({ error }));
    }
}

export function* patchClaimDetailFetchWatch() {
    yield takeEvery('claimDetail/patchClaimDetailFetch', patchClaimDetailFetch);
}

const editClaimDetailEshopNoteFetchRequest = async (params: { idClaim: string; data: { ESHOP_NOTE: string } }) => {
    const res = await api('put', `api/secure/claims/eshop-note/${params.idClaim}`, params.data);
    return res.data;
};

function* editClaimDetailEshopNoteFetch(action: {
    type: string;
    payload: { idClaim: string; data: { ESHOP_NOTE: string } };
}) {
    try {
        const response: ClaimDetailResType = yield call((): any =>
            editClaimDetailEshopNoteFetchRequest(action.payload)
        );
        yield put(
            editClaimDetailEshopNoteFetchSuccess({
                ...response,
                messageSuccess: { title: translate('claims.message.claimUpdate') },
            })
        );
    } catch (error) {
        yield put(editClaimDetailEshopNoteFetchFailure({ error }));
    }
}

export function* editClaimDetailEshopNoteFetchWatch() {
    yield takeEvery('claimDetail/editClaimDetailEshopNoteFetch', editClaimDetailEshopNoteFetch);
}

const getClaimDetailChangelogFetchRequest = async (idClaim: string) => {
    const res = await api('get', withArchiveMode(`api/secure/claims/changelog/${idClaim}`));
    return res.data;
};

function* getClaimDetailChangelogFetch(action: { type: string; payload: string }) {
    try {
        const response: ClaimDetailResType = yield call((): any => getClaimDetailChangelogFetchRequest(action.payload));
        yield put(getClaimDetailChangelogFetchSuccess(response));
    } catch (error) {
        yield put(getClaimDetailChangelogFetchFailure({ error }));
    }
}

export function* getClaimDetailChangelogFetchWatch() {
    yield takeEvery('claimDetail/getClaimDetailChangelogFetch', getClaimDetailChangelogFetch);
}
